import React from "react";

import { FEATURE_NAMES } from "../../../../../../../shared/featureToggles/types";
import ToggleItemWithTooltip from "../../../../../../ToggleItem/ToggleItemWithTooltip";

interface FeatureToggleProps {
  onToggle: (featureName: FEATURE_NAMES) => void;
  isChecked: boolean;
  name: string;
}

const FeatureToggle = ({ onToggle, isChecked, name }: FeatureToggleProps) => {
  return (
    <ToggleItemWithTooltip
      title={name}
      onToggle={onToggle}
      isChecked={isChecked}
    />
  );
};

export default React.memo(FeatureToggle);
